import { FiShoppingCart } from "react-icons/fi";
import { useSelector } from "react-redux";
import styles from "../styles/navbar.module.css";

const CartIcon = () => {
    const cartLength = useSelector((state) => state.cart.items.length);

    return (
        <>
        <FiShoppingCart className={styles.icon} />
        {cartLength > 0 && <span>{cartLength}</span>}
        </>
    )
};

export default CartIcon;
